export default "__VITE_ASSET__BggmDkSK__"